<template>
    <loader v-if="loading" />
    <div v-else>
		<v-row>
			<v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts height="400px" type="line" :options="avgLeadOptions" :series="avgLeadSeries" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
		<v-row>
			<v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts height="400px" type="line" :options="totalOptions" :series="totalSeries" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
		<v-row>
			<v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts height="400px" type="line" :options="countOptions" :series="countSeries" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
		<v-row>
			<v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts v-if="graphType === 'actual'" height="400px" type="line" :options="avgTotalOptions" :series="avgTotalSeries" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
		<v-row>
			<v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts v-if="graphType === 'actual'" height="400px" type="line" :options="avgSaleOptions" :series="avgSaleSeries" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
	components: {
		VueApexCharts
	},
	data() {
		return {
			loading: true,
			avgLeadSeries: [],
			avgSaleSeries: [],
            totalSeries: [],
            avgTotalSeries: [],
            countSeries: [],
			avgLeadOptions: null,
			avgSaleOptions: null,
			totalOptions: null,
			avgTotalOptions: null,
			salesRecords: null
		};
	},
	computed: {
		period() {
			return this.$store.state.development.period;
		},
		team() {
			return this.$store.state.main.team;
		},
		user() {
			return this.$store.state.development.user;
		},
		userSelect() {
			return this.$store.getters["development/userSelect"];
		},
		range() {
			return this.$store.state.development.range;
		},
		chartOptions() {
			return this.$store.state.development.chartOptions;
		},
		categories() {
			return this.$store.state.development.categories;
		},
		granularity() {
			return this.$store.state.development.granularity;
		},
		campaignSelect() {
			return this.$store.getters["development/campaignSelect"];
		},
		campaign() {
			return this.$store.state.development.campaign;
        },
        excludeWinback() {
            return this.$store.state.development.excludeWinback
        },
        excludeInactive() {
            return this.$store.state.development.excludeInactive
        },
        graphType() {
            return this.$store.state.development.graphType
        },
        startDateRange () {
            return this.$store.state.development.startDateRange
        },
        filterStartDate () {
            return this.$store.state.development.filterStartDate
        }
	},
	methods: {
		async getData() {
			this.loading = true;
            const campaigns = this.campaign === 'Alle kampagner' ? null : escape(this.campaign)
            const user = this.user === 'Alle agenturer' ? null : this.user
            let team, department
            if (this.team === 'Alle teams') {
                team = null
            } else if (this.team === 'Tryg') {
                department = 'tryg'
            } else if (this.team === 'Alka') {
                department = 'alka'
            } else {
                team = this.team
            }
			let settings =
				this.user +
				this.campaign +
				this.range.startDate +
				this.range.endDate +
				this.granularity;
			let response = await this.$http().get("/development/sales", {
					params: {
						from: this.range.startDate,
                        to: this.range.endDate,
                        team: team,
                        department: department,
                        campaigns: campaigns,
                        user: user,
                        granularity: this.granularity,
                        excludeWinback: this.excludeWinback,
                        excludeInactive: this.excludeInactive,
                        graphType: this.graphType,
                        startDateFrom: this.filterStartDate ? this.startDateRange[0] : null,
                        startDateTo: this.filterStartDate ? this.startDateRange[1] : null
					}
				});
			if (
				settings ===
				this.user +
					this.campaign +
					this.range.startDate +
					this.range.endDate +
					this.granularity
			) {
				this.avgLeadSeries = [response.data.series.avgLeadSeries]
				this.avgSaleSeries = [response.data.series.avgSaleSeries]
				this.totalSeries = [response.data.series.totalSeries]
				this.avgTotalSeries = [response.data.series.avgTotalSeries]
				this.countSeries = [response.data.series.countSeries]
				this.$store.commit("development/setChartOptions", {
					formatter: this.$options.filters.separator,
					categories: response.data.labels
				});
				this.setAvgLeadOptions();
				this.setAvgSaleOptions();
				this.setTotalOptions();
				this.setAvgTotalOptions();
				this.setCountOptions();
				this.loading = false;
			}
		},
		setAvgLeadOptions() {
			this.avgLeadOptions = {
				...this.chartOptions,
				colors: ["#00ff00"],
				title: {
					text: "Salg pr. emne"
				},
                yaxis: {
                    labels: {
                        formatter: this.$options.filters.separator
                    }
                }
			}
		},
		setAvgSaleOptions() {
			this.avgSaleOptions = {
				...this.chartOptions,
				colors: ["#0000ff"],
				title: {
					text: "Gns. præmie"
                },
                yaxis: {
                    labels: {
                        formatter: this.$options.filters.separator
                    }
                }
			}
		},
		setTotalOptions() {
			this.totalOptions = {
				...this.chartOptions,
				colors: ["#ff0000"],
				title: {
					text: "Solgt præmie"
                },
                yaxis: {
                    labels: {
                        formatter: this.$options.filters.separator
                    }
                }
			}
		},
		setAvgTotalOptions() {
			this.avgTotalOptions = {
				...this.chartOptions,
				colors: ["#ff0000"],
				title: {
					text: "Solgt præmie pr. agentur"
                },
                yaxis: {
                    labels: {
                        formatter: this.$options.filters.separator
                    }
                }
			}
		},
		setCountOptions() {
			this.countOptions = {
				...this.chartOptions,
				colors: ["#00ffff", "#0000ff"],
				title: {
					text: "Afsluttede"
				}
			};
		}
	},
	watch: {
		userSelect: function() {
			this.getData();
		},
		period: function(preset) {
			this.$store.commit("development/setRange", preset);
		},
		range: {
			handler() {
				this.getData();
			},
			deep: true
        },
        filterStartDate: function () {
            this.getData()
        },
		startDateRange: {
			handler({ length }) {
                if (length === 2) this.getData();
			},
			deep: true
		},
		user: function() {
			this.getData();
		},
		campaign: function() {
			this.getData();
		},
		granularity: function() {
			this.getData();
        },
        excludeWinback: function() {
			this.getData();
        },
        excludeInactive: function() {
			this.getData();
        },
        graphType: function () {
            this.getData()
        }
	},
	created() {
        this.$store.state.development.excludeWinback = true
        this.$store.state.development.tab = 'sales'
		if (this.userSelect.length > 1) {
			this.getData();
        }
	}
};
</script>

<style lang="scss">
.toggle-chart {
    position: absolute;
    top: -1.25rem;
    left: 13ch;
}
.apexcharts-data-labels text {
    z-index: 999999;
}
</style>